import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { camundaTasklistUrl } from '../../camundaHelper';

const TaskLinkAction = () => (
  <RibbonMenu
    name="tasks"
    icon="tasks"
    message="actions.user.tasks"
    url={camundaTasklistUrl()}
    target="_blank"
    className="aridhia-task-link-action-menu whitespace-nowrap"
  />
);

export default TaskLinkAction;
